<template>
  <DefaultLayout>
    <v-container fluid style="overflow-y: auto; height: 100%;" class="pt-0">
      <div class="d-flex flex-column align-center overflow-auto" style="height: 100%; padding-top: var(--top-offset);">
        <div class="kirjeldus pa-4">
          Kriminaalhooldusportaali eesmärk on toetada kriminaalhoolduse läbimist ning olla kasutaja virtuaalne toimik.
        </div>
        <div class="kirjeldus pa-4 mb-12">
          Kui Teil on riigi poolt kättetoimetamist vajavaid dokumente, siis suunatakse Teid esmalt Kättetoimetamise portaali.
          <br>
          Kui Te pole dokumente vastu võtnud, ei ole võimalik portaali kasutada.
        </div>
        <div>
          <v-btn color="primary" @click="logiSisse">Sisene</v-btn>
        </div>
      </div>
    </v-container>
  </DefaultLayout>
</template>

<style scoped>
.kirjeldus {
  font-size: 22px;
  line-height: 28px;
  text-align: center;
  max-width: 1200px;
}
.v-btn {
    width: 200px;
}
</style>
<script lang="ts">
import { defineComponent } from 'vue';
import { AuthTeenus } from '@/core/auth-teenus';
import { useKasutajaStore } from '@/stores/kasutajaStore';
import { useAmetnikStore } from '@/stores/ametnikStore';
import { useTeavitusedStore } from '@/stores/teavitusedStore';
import { useTegevusedStore } from '@/stores/tegevusedStore';
import { useUldkasulikTooStore } from '@/stores/uldkasulikTooStore';
import DefaultLayout from "@/components/uldine/DefaultLayout.vue";

const _authTeenus = new AuthTeenus();

export default defineComponent({
    name: 'MaandumisLeht',
    components: {DefaultLayout},
    async mounted() {
        const userStore = useKasutajaStore();
        const ametnikStore = useAmetnikStore();
        const teavitusedStore = useTeavitusedStore();
        const tegevusedStore = useTegevusedStore();
        const uldkasulikTooStore = useUldkasulikTooStore();

        ametnikStore.eemaldaAmetnik();
        teavitusedStore.eemaldaTeavitused();
        tegevusedStore.eemaldaTegevused();
        uldkasulikTooStore.eemaldaUldkasulikToo();

        const checkAuth = await _authTeenus.kontrolliAuthi();

        if (userStore.kasutaja) {
            if (checkAuth?.isAuth) {
                this.$router.push({ name: 'Avaleht' });
            }
        }
        else {
            userStore.$subscribe((kasutaja) => {
                if (kasutaja) {
                    this.$router.push({ name: 'Avaleht' });
                }
            });
        }
    },
    methods: {
        logiSisse() {
            _authTeenus.logiSisse();
        }
    }
});
</script>